/**
 * Singleton camera state manager that persists across React component remounts
 * Tracks camera open/close state to restore after orientation changes
 */

class CameraManager {
    private static instance: CameraManager;
    private isActive = false;

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    private constructor() {}

    static getInstance(): CameraManager {
        if (!CameraManager.instance) {
            CameraManager.instance = new CameraManager();
        }
        return CameraManager.instance;
    }

    show() {
        this.isActive = true;
    }

    hide() {
        this.isActive = false;
    }

    isOpen(): boolean {
        return this.isActive;
    }
}

export const cameraManager = CameraManager.getInstance();
